import { Button, makeStyles, tokens } from '@fluentui/react-components';
import { useAutomationRuleActions } from './use-actions';

interface Props {
  isLast?: boolean;
	itsFirst?: boolean;
}

export default function FormDividerActions(props: Props){
	const {actions, addNewAction} = useAutomationRuleActions();
	const classes = useStyles();

	return (
		<>
			{props.itsFirst && <div className={classes.formDivider} />}
			{(!props.itsFirst && actions.length > 0) && (<div className={classes.formDivider} />)}
			{(!actions.length || props.isLast) && (
				<Button
					size='small'
					onClick={() => {addNewAction();	
					}}
				>
          Add action
				</Button>
			)}
		</>
	);
}

const useStyles = makeStyles({
	formDivider: {
		height: '32px',
		width: '1px',
		backgroundColor: tokens.colorNeutralForegroundDisabled,
		marginLeft: '32px'
	}
});